'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _app = require('./app/app.module');

var _app2 = _interopRequireDefault(_app);

var _auth = require('./auth/auth.module');

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('app.components', [_app2.default, _auth2.default]).name;


// WEBPACK FOOTER //
// ./components/components.module.js